export default "__VITE_ASSET__DGZtHbv6__"